export default __webpack_public_path__ + "static/media/up-arrow-svgrepo-com_3.db3f87f0.svg";